import React, { useEffect, useRef, useState } from 'react';

export default function LegacyIntercomButton() {
    const launcherRef = useRef(null);
    const unreadCountRef = useRef(null);

    useEffect(() => {
        const launcher = launcherRef.current;
        const unreadCountEl = unreadCountRef.current;

        if (!launcher) return;

        const handleShow = () => launcher.classList.add('intercom-open');
        const handleHide = () => launcher.classList.remove('intercom-open');
        const handleUnreadCount = (count) => {
            if (unreadCountEl) {
                unreadCountEl.textContent = count;
                if (count) {
                    unreadCountEl.classList.add('active');
                } else {
                    unreadCountEl.classList.remove('active');
                }
            }
        };

        window.Intercom('onShow', handleShow);
        window.Intercom('onHide', handleHide);
        window.Intercom('onUnreadCountChange', handleUnreadCount);

        const interval = setInterval(() => {
            if (window.Intercom.booted) {
                launcher.classList.add('intercom-booted');
                clearInterval(interval);
                clearTimeout(timeout);
            }
        }, 100);
        const timeout = setTimeout(() => clearInterval(interval), 30000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
            window.Intercom('off', 'onShow', handleShow);
            window.Intercom('off', 'onHide', handleHide);
            window.Intercom('off', 'onUnreadCountChange', handleUnreadCount);
        };
    }, []);

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a ref={launcherRef} className="intercom-launcher intercom-button">
            <div className="intercom-icon-close"></div>
            <div className="intercom-icon-open"></div>
            <span ref={unreadCountRef} className="intercom-unread-count"></span>
        </a>
    );
}
